(function () {
    'use strict';
    Component_IntakeDataViewerController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'OrderBagCustom', 'CompanyCustomerCustom', 'ENV'];

    function Component_IntakeDataViewerController($scope, $attrs, $element, FileUtil, OrderBagCustom, CompanyCustomerCustom, ENV) {
//
        var $ctrl = this;
        $ctrl.isDataLoaded = false;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isEditMode = true;
        $ctrl.save = save;
        $ctrl.cancelEditing = cancelEditing;
        $ctrl.gotoEditMode = gotoEditMode;
        $ctrl.tempIntakeData = null;
        $ctrl.findColumnCountClass = findColumnCountClass;
        $ctrl.values = {}
        function save() {
            if ($ctrl.intakeData.intakeParentType == "ORDER_BAG") {
                OrderBagCustom.updateIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;

                })
            }
            if ($ctrl.intakeData.intakeParentType == "COMPANY_CUSTOMER") {
                CompanyCustomerCustom.updateCustomerIntakeFormData().save($ctrl.intakeData, function () {
                    $ctrl.isEditMode = false;
                })
            }


        }

        function gotoEditMode() {
            $ctrl.tempIntakeData = JSON.parse(JSON.stringify($ctrl.intakeData));
            $ctrl.isEditMode = true;
        }

        function cancelEditing() {
            $ctrl.intakeData = $ctrl.tempIntakeData;
            $ctrl.isEditMode = false;
        }

        function downloadFile(field) {

            var filename = field.value.replace('file:uploadroot/', '');
            FileUtil.downloadUploadedFile(filename);
        }

        function findColumnCountClass() {
            switch ($ctrl.columnCount) {
                case 1 :
                    return "col-sm-12";
                case 2 :
                    return "col-sm-6";
                case 3 :
                    return "col-sm-4";
                case 4 :
                    return "col-sm-3";
                case 6 :
                    return "col-sm-2";
            }
        }

        $scope.$watch('$ctrl.intakeData', function (intakeData) {
            if (intakeData) {
                $ctrl.isDataLoaded = true;
                angular.forEach(intakeData.fields, function (field) {
                    if (field.value) {
                        $ctrl.values[field.name] = field.value
                        if (field.value.startsWith('file:uploadroot')) {
                            field.isFile = true;
                            var filename = field.value.replace('file:uploadroot/', '');
                            field.href = ENV.API_BASE_URL + 'api/client/downloadfile?fileName=' + filename;
                        }


                        if (field.field.fieldType == 'CheckBox') {
                            field.checkValue = convertStringToBoolean(field.value);
                        }

                    }
                });

            }


        },true);

    }


    var Component_IntakeDataViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data-component/component-intake-data-viewer.template.html',
        controller: Component_IntakeDataViewerController,
        bindings: {
            intakeData: '=',
            columnCount: '='
        }

    };

    angular
        .module('tikonApp')
        .component('componentIntakeDataViewer', Component_IntakeDataViewer)

})();
